import { Theme } from '@mui/material';

export const sxStyles = {
  pageWrap: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
  },
  accordionDetails: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
  },
  summaryTitlesWrap: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
  },
  infoText: (theme: Theme) => ({
    color: theme.palette.grey['500'],
  }),
  checkboxGroup: {
    gap: '0.5rem',
  },
};
